import './Flex.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Flex Component
 * @augments {Component<Props, State>}
 */
class Flex extends Component {
    render() {
        const { children } = this.props;
        return (
            <div className={'Flex'}>
                {children}
            </div>
        );
    }
}

Flex.defaultProps = {};

Flex.propTypes = {
    children: PropTypes.shape().isRequired,
};

export default Flex;